module.exports = __webpack_public_path__ + "assets/img/abonnemang.578731f7.png";